module.exports = __webpack_public_path__ + "img/logo.94e5c7b1.png";